import { Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as CheckCircle } from '../../../res/svg/check-circle-tone.svg';
import './SuccessMessage.less';

/**
 * @component SuccessMessage.tsx
 * @description SuccessMessage component
 * @return { Component }
 */
interface SuccessMessageProps {
  userName: string;
}
function SuccessMessage(props: SuccessMessageProps) {
  const { Title, Text } = Typography;
  let navigate = useNavigate();
  return (
    <div className="ml-success__main">
      <CheckCircle />
      <Title className="ml-success__main__title">¡Bien hecho!</Title>
      <Text type="secondary">
        Restableciste tu contraseña para tu correo <b>{props.userName}</b>
      </Text>
      <Text type="secondary" className="ml-success__main__subtitle">
        Te sugerimos anotarla en algún lugar seguro para no olvidarla.
      </Text>
      <Button
        className="ml-success__main__button"
        type="primary"
        htmlType="submit"
        shape="round"
        size={'large'}
        onClick={() => {
          navigate('/login');
        }}
      >
        Iniciar sesión
      </Button>
    </div>
  );
}

export default SuccessMessage;
